module.exports = __webpack_public_path__ + "static/media/Gotham-Black.3ede438c.woff";